// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { focusedItemText, headerText, itemText, linkStyles } from "@conklin/App/SharedStyles/AutoCompleteSharedStyles";
import { autocompleteCategoriesStyles } from "@conklin/Overrides/Widgets/Header/AutocompleteCategories";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { mergeWithCss } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

autocompleteCategoriesStyles.headerText = {
    ...mergeWithCss(headerText, {
        css: css`
            margin: 0 0 8px 0;
        `,
    }),
};

autocompleteCategoriesStyles.link = {
    ...linkStyles,
    typographyProps: {
        ...linkStyles.typographyProps,
        weight: fontConfig.weight.bold,
        color: "text.link",
    },
};

autocompleteCategoriesStyles.categoryItemText = {
    ...itemText,
    weight: fontConfig.weight.bold,
};

autocompleteCategoriesStyles.inText = {
    ...itemText,
    weight: fontConfig.weight.regular,
};

autocompleteCategoriesStyles.focusedCategoryItemText = {
    ...focusedItemText,
    weight: fontConfig.weight.bold,
};

autocompleteCategoriesStyles.focusedLink = linkStyles;
